import React, { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
    Button,
    Checkbox,
    FormControlLabel,
    FormGroup,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
    useStylesUp, useStylesHed, useStylesAuto,useStylesAutoPurch,useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,useStylesAutoSafe
} from '../../../../St/Reports/UseStyle';

export default function ItemsMovementTotalForm(props) {
    const {
        AutoOptions,
        rptParams,
        onChangeData,
        onChangeAutoData,
        typeSearch,
        items,
        subUnit,
        maxUnit,
        onChangeAutoDataCurr,
    } = props;

    const { t } = useTranslation(["forms"]);

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasASafe = useStylesAutoSafe();



    const clashd = useStylesHed();
    const clasBA = useStylesBA();
    const clasTD = useStylesTD();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>

                <Grid item lg={2} md={2} sm={3} xs={6}  style={{paddingBottom:"0.5rem"}}>
                    <TextField fullWidth variant="outlined" size="small" id="dateFrom" 
                    label={t("date-from")}
                         className={clasTF.rootSafe}InputProps={{ className: claslbl.clrSafe }}
                        type="date" format="YYYY-MM-DD"
                        name="dateFrom" value={rptParams.dateFrom} onChange={onChangeData('dateFrom')}
                    /></Grid>
              
                <Grid item lg={2} md={2} sm={3} xs={6} style={{paddingBottom:"0.5rem"}}>
                    <TextField fullWidth variant="outlined" size="small" id="dateTo" 
                    label={t("date-to")}
                         className={clasTF.rootSafe} InputProps={{className:claslbl.clrSafe}}
                        type="date" format="YYYY-MM-DD"
                        name="dateTo" value={rptParams.dateTo} onChange={onChangeData('dateTo')}
                    /></Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{paddingBottom:"0.5rem"}}>
                    <Autocomplete
                      classes={clasASafe}
                      value={rptParams.curr}
                      onChange={(event, newValue) => {
                        onChangeAutoDataCurr("curr", newValue);
                        // console.log(newValue);
                      }}
                      id="controllable-states-demo"
                      size="small"
                      options={items}
                      getOptionLabel={(option) =>
                        typeof option === "string"
                          ? option
                          : option?.barcode?.toString()
                      }
                      disableClearable
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("item_barcode")}
                          variant="outlined"
                          size="small"
                          InputLabelProps={{ className:claslbl.clrSafe}}
                        />
                      )}
                    />
                   
                  </Grid>
                  <Grid item lg={2} md={2} sm={3} xs={6} style={{paddingBottom:"0.5rem"}}>
                    <Autocomplete classes={clasASafe}
                        value={rptParams.curr}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoDataCurr('curr', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={items}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params} 
                        label={t("item_name")} variant="outlined" size="small"
                            InputLabelProps={{className:claslbl.clrSafe }} />}
                    />
                </Grid>
                  {rptParams.curr.id !=-1 &&
                     <Grid item lg={2} md={2} sm={3} xs={6} style={{paddingBottom:"0.5rem"}}>
                     <Autocomplete
                       classes={clasASafe}
                       value={rptParams.subUnit}
                       onChange={(event, newValue) => {
                         onChangeAutoData("subUnit", newValue);
                         // console.log(newValue);
                       }}
                       id="controllable-states-demo"
                       size="small"
                       options={subUnit}
                       getOptionLabel={(option) =>
                         typeof option === "string"
                           ? option
                           : option?.unitName?.toString()
                       }
                       disableClearable
                       renderInput={(params) => (
                         <TextField
                           {...params}
                           label={t("item_units")}
                           variant="outlined"
                           size="small"
                           InputLabelProps={{ className:claslbl.clrSafe}}
                         />
                       )}
                     />
                    
                   </Grid>}
                   {rptParams.curr.id ===-1 &&
                     <Grid item lg={2} md={2} sm={3} xs={6} style={{paddingBottom:"0.5rem"}}>
                     <Autocomplete
                       classes={clasASafe}
                       value={rptParams.maxUnit}
                       onChange={(event, newValue) => {
                         onChangeAutoData("maxUnit", newValue);
                         // console.log(newValue);
                       }}
                       id="controllable-states-demo"
                       size="small"
                       options={maxUnit}
                       getOptionLabel={(option) =>
                         typeof option === "string"
                           ? option
                           : option?.name?.toString()
                       }
                       disableClearable
                       renderInput={(params) => (
                         <TextField
                           {...params}
                           label={t("sort_by")}
                           variant="outlined"
                           size="small"
                           InputLabelProps={{ className:claslbl.clrSafe}}
                         />
                       )}
                     />
                    
                   </Grid>}
   
                <Grid item lg={2} md={2} sm={3} xs={6} style={{paddingBottom:"0.5rem"}}>
                    <Autocomplete classes={clasASafe}
                        value={rptParams.safe}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoData('safe', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={AutoOptions.Safes}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params} label={t("safe")} variant="outlined" size="small"
                            InputLabelProps={{ className:claslbl.clrSafe } } />}
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{paddingBottom:"0.5rem"}}>
                    <Autocomplete classes={clasASafe}
                        value={rptParams.branch}
                        onChange={(event, newValue) => {
                            //   setBranch(newValue);
                            onChangeAutoData("branch", newValue);

                        }}
                        id="combo-box-demo"
                        size="small"
                        options={AutoOptions.Branches}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }

                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("branch")}
                                variant="outlined"
                                InputLabelProps={{ className:claslbl.clrSafe } }
                            />
                        )}
                        
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{paddingBottom:"0.5rem"}}>
                    <Autocomplete classes={clasASafe}
                        value={rptParams.typeSearch}
                        onChange={(event, newValue) => {
                            onChangeAutoData("typeSearch", newValue);
                        }}
                        id="combo-box-demo"
                        size="small"
                        options={typeSearch}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }

                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("sort_by")}
                                variant="outlined"
                                InputLabelProps={{ className:claslbl.clrSafe } }
                            />
                        )}
                        
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{paddingBottom:"0.5rem"}}>
                    <Autocomplete classes={clasASafe}
                        value={rptParams.center}
                        onChange={(event, newValue) => {
                            //   setBranch(newValue);
                            onChangeAutoData("center", newValue);

                        }}
                        id="combo-box-demo"
                        size="small"
                        options={AutoOptions.center}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }

                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("center")}
                                variant="outlined"
                                InputLabelProps={{ className:claslbl.clrSafe } }
                            />
                        )}   
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
